module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	/**
	 * i18nTransform Component for VE
	 * @author alex.mm
	 *
	 * Copyright 2014-2016.
	 * All rights reserved.
	 */

	var isObject = function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	};
	var hasOwn = function hasOwn(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};
	var reg = /_raw_6i611ynz$/;

	/**
	 * return {
	 *   'key': {
	 *     zh_CN: '中文',
	 *     en_US: 'chinese',
	 *   }
	 * }
	 */

	function i18nDataTransform(i18nData) {
	  var data = {};
	  if (Array.isArray(i18nData)) {
	    i18nData.forEach(function (value) {
	      data[value.i18nKey] = value.i18nText;
	    });
	    return data;
	  }
	  return i18nData;
	}

	function mergeData(obj, data) {
	  if (obj.key) {
	    return _extends({}, obj, data[obj.key]);
	  }
	  return obj;
	}

	/**
	 * old
	 * obj: {
	 *   type: 'i18n',
	 *   zh_CN: '中文',
	 *   en_US: 'chinese',
	 * }
	 * new
	 * obj: {
	 *   type: 'i18n',
	 *   key: 'key',
	 * }
	 */

	var i18nTransform = function i18nTransform(obj) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zh_CN';
	  var i18nData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var withRaw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  var defaultLocale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'zh_CN';

	  if (!obj) return obj;
	  if (withRaw) {
	    return i18nTransform.transformWithRaw(obj, locale, i18nData, defaultLocale);
	  }
	  var data = i18nDataTransform(i18nData);
	  if (Array.isArray(obj)) {
	    return obj.map(function (item) {
	      return i18nTransform(item, locale, i18nData);
	    });
	  }
	  if (isObject(obj)) {
	    if (obj.type === 'i18n') {
	      obj = mergeData(obj, data);
	      // `use` 是强制使用的环境语言，优先级高于`locale`，用于单值的情况
	      return obj[obj.use || locale] || (obj.key ? '' : obj[defaultLocale]);
	    }
	    var out = {};
	    Object.keys(obj).forEach(function (key) {
	      out[key] = i18nTransform(obj[key], locale, i18nData);
	    });
	    return out;
	  }
	  return obj;
	};

	i18nTransform.transformWithRaw = function (obj) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zh_CN';
	  var i18nData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var defaultLocale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'zh_CN';

	  if (!obj) return obj;
	  var data = i18nDataTransform(i18nData);
	  if (Array.isArray(obj)) {
	    return obj.map(function (item) {
	      return i18nTransform.transformWithRaw(item, locale, i18nData);
	    });
	  }
	  if (isObject(obj)) {
	    if (obj.type === 'i18n') {
	      obj = mergeData(obj, data);
	      // `use` 是强制使用的环境语言，优先级高于`locale`，用于单值的情况
	      return obj[obj.use || locale] || (obj.key ? '' : obj[defaultLocale]);
	    }
	    var out = {};
	    Object.keys(obj).forEach(function (key) {
	      var isRaw = reg.test(key);
	      if (isObject(obj[key]) && obj[key].type === 'i18n') {
	        if (isRaw) {
	          out[key] = obj[key];
	        } else {
	          out[key + '_raw_6i611ynz'] = mergeData(obj[key], data);
	        }
	      }
	      if (!isRaw) {
	        out[key] = i18nTransform.transformWithRaw(obj[key], locale, i18nData);
	      }
	    });
	    return out;
	  }
	  return obj;
	};

	i18nTransform.restore = function (obj) {
	  if (!obj) return obj;
	  if (Array.isArray(obj)) {
	    return obj.map(function (item) {
	      return i18nTransform.restore(item);
	    });
	  }
	  if (isObject(obj)) {
	    var out = {};
	    Object.keys(obj).forEach(function (key) {
	      var isRaw = reg.test(key);
	      if (isObject(obj[key]) && obj[key].type === 'i18n') {
	        if (isRaw) {
	          var rawKey = key.replace(reg, '');
	          out[rawKey] = obj[key];
	        } else {
	          out[key] = obj[key];
	        }
	      }
	      if (!isRaw && !hasOwn(out, key)) {
	        out[key] = i18nTransform.restore(obj[key]);
	      }
	    });
	    return out;
	  }
	  return obj;
	};

	i18nTransform.i18nDataTransform = i18nDataTransform;

	exports.default = i18nTransform;
	module.exports = exports['default'];

/***/ }
/******/ ]);